document.addEventListener("tbyb_cart_update", function() {
  var targetLink = document.querySelector('a[href="/cart"][data-no-instant].relative.tap-area');
  var parentElement = document.querySelector('.cart-drawer__line-items'); if (null === parentElement) return;
  var targetElements1 = parentElement.querySelectorAll('.tbyb-bmqjcu');
  var targetElements2 = parentElement.querySelectorAll('[data-tbyb="tbyb-minicart-warning"]');

  if (null === targetElements1 || null === targetElements2 || null === targetLink) {return;}

  // Initial check for targetElements1
  targetElements1.forEach(function(targetElement1) {
    if (targetLink.getAttribute('aria-expanded') === 'true') {
      targetElement1.style.setProperty('display', 'block', 'important');
    } else {
      targetElement1.style.setProperty('display', 'none', 'important');
    }
  });

  // Initial check for targetElements2
  targetElements2.forEach(function(targetElement2) {
    if (targetLink.getAttribute('aria-expanded') === 'true') {
      targetElement2.style.setProperty('display', 'block', 'important');
    } else {
      targetElement2.style.setProperty('display', 'none', 'important');
    }
  });

  // Event listener for attribute change
  var observer = new MutationObserver(function(mutationsList) {
    for (var mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'aria-expanded') {
        targetElements1.forEach(function(targetElement1) {
          if (mutation.target.getAttribute('aria-expanded') === 'true') {
            targetElement1.style.setProperty('display', 'block', 'important');
          } else {
            targetElement1.style.setProperty('display', 'none', 'important');
          }
        });

        targetElements2.forEach(function(targetElement2) {
          if (mutation.target.getAttribute('aria-expanded') === 'true') {
            targetElement2.style.setProperty('display', 'block', 'important');
          } else {
            targetElement2.style.setProperty('display', 'none', 'important');
          }
        });
      }
    }
  });

  observer.observe(targetLink, { attributes: true });
});

document.addEventListener("tbyb_cart_update", function() {
  var orderSummaryItems = document.querySelectorAll('.order-summary__body');

  orderSummaryItems.forEach(function(orderSummaryItem) {
    var tbybTagElement = orderSummaryItem.querySelector('.tbyb-tag.tbyb-bmqjcu');
    var targetElement = orderSummaryItem.querySelector('.hidden.align-center.text-subdued.text-end.sm\\:table-cell');

    if (tbybTagElement && targetElement) {
      targetElement.textContent = "$0";
    }
  });
});


document.addEventListener("tbyb_cart_update", function() {
  // Select all elements with the class "view-cart-button"
  var elements = document.getElementsByClassName("view-cart-button");

  // Loop through each element
  for (var i = 0; i < elements.length; i++) {
    // Check the value of tbyb.validator.isQualified
    if (tbyb.validator.isQualified) {
      // If true, add a "display: none" rule to the element
      elements[i].style.display = "none";
    } else {
      // If false, add a "display: block" rule to the element
      elements[i].style.display = "block";
    }
  }
});

document.addEventListener("tbyb_cart_update", function() {
  // Select the container holding all the line items
  var lineItemsContainer = document.querySelector(".cart-drawer__line-items");
  if (null === lineItemsContainer) return this;

  // Select all line item containers within the line items container
  var lineItemContainers = lineItemsContainer.querySelectorAll(".line-item");
  if (null === lineItemContainers) return this;

  // Loop through each line item container
  for (var i = 0; i < lineItemContainers.length; i++) {
    var lineItemContainer = lineItemContainers[i];
    
    // Check if the line item is TBYB
    var isTbyb = lineItemContainer.querySelector(".tbyb-tag") !== null;

    // Find the quantity input within the line item container
    var quantityInput = lineItemContainer.querySelector('[data-tbyb="quantity-control"]');

    // Find the quantity input's ID
    var quantityInputId = quantityInput.getAttribute("id");

    // Disable or enable the quantity input based on TBYB status
    if (isTbyb) {
      quantityInput.disabled = true;
    } else {
      quantityInput.disabled = false;
    }
  }
});
document.addEventListener("tbyb_cart_update", function() {
  // // Select all elements with the class "tbyb-1izyex6"
  // var elements = document.getElementsByClassName("tbyb-1izyex6");

  // // Check if there is a second instance of the class
  // if (elements.length >= 2) {
  //   // Get the value within the second instance
  //   var value = elements[1].textContent.trim();

  //   // Find the element with the class "upfront-price-loader"
  //   var upfrontPriceLoader = document.querySelector(".upfront-price-loader");

  //   // Set the value of the upfront-price-loader element
  //   upfrontPriceLoader.textContent = value;
  // }
});

// function to append new Blackcart TBYB toggle copy
document.addEventListener("tbyb_cart_update", function () {
    var productId = tbyb.getSelectedVariants()?.productId
    if (productId) {
      var eligible = tbyb.viewManager.eligibilityService.getEligibilityStatus(productId)
      if (eligible.state) {
        if (document.querySelector("#toggle_deposit_text")) {
          return
        }
        var elem = document.querySelector("#blackcart_info")
        if (elem) {
          // get deposit
          var deposit = tbyb.validator.validatedCartInfo?.deposit
          if (deposit) {
            p = document.createElement("p");
            p.setAttribute("id", "toggle_deposit_text");
           p.innerHTML = 'Try all mattresses & sleep systems for 120 days, and all adjustable beds for 30 days. Payment won\'t be charged until 30 days after delivery. Try with a $50 refundable deposit.  ' + '&nbsp';
 elem.prepend(p)
          }
        }
      }
    }
})
// Function to determine if it's a mobile or desktop window
function isMobileWindow() {
  const windowWidth = window.innerWidth;
  const mobileThreshold = 768;
  return windowWidth < mobileThreshold;
}

// Function to handle the tbyb_cart_update event
function handleCartUpdate() {
  // Select the first container with the class name "tbyb-3umn2w"
  const container = document.querySelector('.tbyb-3umn2w:first-of-type');

  // Check if the container element exists
  if (container) {
    // Add the CSS rule to hide the container
    container.style.display = 'none !important';
  }

  // Remove the event listener after the first execution
  document.removeEventListener('tbyb_cart_update', handleCartUpdate);
}

// Add the event listener for tbyb_cart_update
document.addEventListener('tbyb_cart_update', handleCartUpdate);

document.addEventListener("DOMContentLoaded", function() {
  const buyButton = document.querySelector('buy-buttons[form*="__featured_product"]');
  if (buyButton) {
    const tbybButton = buyButton.querySelector('[data-tbyb="tbyb-button"]');
    if (tbybButton) {
      tbybButton.remove();
    } else {
      console.log('tbybButton element not found');
    }
  } else {
    console.log('Element not found');
  }
});
